// 로그아웃
export function LogoutSession(sign) {
  if (sign === true) {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userName");

    alert("You have been logged out. \n Go to the main page");
    window.location.href = "/";
  }
}
